// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '8c355c05-4a1c-4b30-8204-0636a0e0f63a',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '46c7f429-382a-4672-9e3d-abeca7af9f41',
      type: 'Sprite',
      name: 'flag',
      className: '',
      x: 0,
      y: 6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Flag_Main_Menu_Icon_Gold',
      parent: '8c355c05-4a1c-4b30-8204-0636a0e0f63a',
      stateByName: {
        '2nd': {
          texture: 'Race_Event_Flag_Main_Menu_Icon_Silver'
        },
        '3rd': {
          texture: 'Race_Event_Flag_Main_Menu_Icon_Bronze'
        },
        '4th': {
          texture: 'Race_Event_Flag_Main_Menu_Icon_Grey'
        },
        '5th': {
          texture: 'Race_Event_Flag_Main_Menu_Icon_Grey'
        }
      }
    },
    {
      id: 'eebb7425-6055-450d-8d9a-0715dc311b05',
      type: 'Text',
      name: 'rankText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1st',
      localize: true,
      maxWidth: 57,
      maxHeight: 45,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#a35728',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '8c355c05-4a1c-4b30-8204-0636a0e0f63a',
      stateByName: {
        '2nd': {
          text: '2nd',
          style: {
            stroke: '#024da0'
          }
        },
        '3rd': {
          text: '3rd',
          style: {
            stroke: '#9a422a'
          }
        },
        '4th': {
          text: '4th',
          style: {
            stroke: '#52606F'
          }
        },
        '5th': {
          style: {
            stroke: '#52606F'
          },
          text: '5th'
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  stateNames: [
    '2nd',
    '3rd',
    '4th',
    '5th'
  ],
  handleResize: false
} as const;

export class RaceEventSmallRankFlagLayout {
  static raw = raw;
  root!: Container;
  flag!: Sprite;
  rankText!: Text;
  StateName!: '2nd' | '3rd' | '4th' | '5th';

  constructor() {
    populate(this, raw);
  }
}
